(() => {
  const STATUS_ID = 'tbk-a11y-status';
  const STATEMENT_PATH = '/pages/accessibility-statement';

  function statusNode() {
    return document.getElementById(STATUS_ID);
  }

  function announce(message) {
    const node = statusNode();
    if (!node || !message) return;
    node.textContent = '';
    window.setTimeout(() => {
      node.textContent = message;
    }, 30);
  }

  function ensureMainContentTarget() {
    const main = document.getElementById('MainContent') || document.querySelector('main, [role="main"]');
    if (!main) return;
    if (!main.id) main.id = 'MainContent';
    if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
  }

  function setLabel(el, label) {
    if (!el || !label) return;
    const text = (el.textContent || '').trim();
    if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby') && !text) {
      el.setAttribute('aria-label', label);
    }
    if (el.tagName === 'A' && !el.getAttribute('title')) {
      el.setAttribute('title', label);
    }
  }

  function labelIconControls() {
    [
      ['a[href*="/search"], button[aria-controls*="Search"], .header__icon--search', 'Search'],
      ['a[href*="/account"], .header__icon--account', 'Account'],
      ['a[href*="/cart"], .header__icon--cart, cart-icon-bubble a', 'Cart'],
      ['a[href*="instagram.com"], .header__icon--instagram', 'Open TBK Motorsports Instagram']
    ].forEach(([selector, label]) => {
      document.querySelectorAll(selector).forEach(el => setLabel(el, label));
    });
  }

  function normalizeMissingImageAlts() {
    document.querySelectorAll('img:not([alt])').forEach(img => {
      const labelled = img.closest('[aria-label]')?.getAttribute('aria-label') || img.getAttribute('title') || '';
      img.setAttribute('alt', labelled.trim());
    });
  }

  function labelQuantityInputs() {
    document.querySelectorAll('input[type="number"][name*="quantity"], input.quantity__input').forEach(input => {
      if (!input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) {
        input.setAttribute('aria-label', 'Quantity');
      }
    });
  }

  function ensureAriaReferenceTargets() {
    document.querySelectorAll('[aria-controls], [aria-owns]').forEach(el => {
      ['aria-controls', 'aria-owns'].forEach(attr => {
        const value = el.getAttribute(attr);
        if (!value) return;
        const ids = value.split(/\s+/).filter(Boolean);
        const validIds = ids.filter(id => document.getElementById(id));
        if (validIds.length) {
          el.setAttribute(attr, validIds.join(' '));
        } else {
          el.removeAttribute(attr);
        }
      });
    });
  }

  function ensureSubmitFallback(form, label) {
    if (!form || form.querySelector('button[type="submit"], input[type="submit"], input[type="image"]')) return;
    const button = document.createElement('button');
    button.type = 'submit';
    button.className = 'tbk-a11y-submit-fallback';
    button.textContent = label;
    form.appendChild(button);
  }

  function addMissingSubmitButtons() {
    ensureSubmitFallback(document.getElementById('FacetFiltersForm'), 'Apply filters');
    ensureSubmitFallback(document.getElementById('FacetFiltersFormMobile'), 'Apply filters');

    document.querySelectorAll('form[id^="product-form-installment"]').forEach(form => {
      ensureSubmitFallback(form, 'Submit payment plan form');
    });
  }

  function applyInlineContrastFixes() {

    document.querySelectorAll('input.quantity__input, input[id^="Quantity-"]').forEach(input => {
      input.style.setProperty('background', '#fff', 'important');
      input.style.setProperty('background-color', '#fff', 'important');
      input.style.setProperty('background-image', 'none', 'important');
      input.style.setProperty('color', '#101010', 'important');
      input.style.setProperty('-webkit-text-fill-color', '#101010', 'important');
      input.style.setProperty('box-shadow', 'inset 0 0 0 1000px #fff', 'important');
      input.style.setProperty('opacity', '1', 'important');
    });
  }

  function makeClickableBlocksKeyboardUsable() {
    document.querySelectorAll('[onclick]:not(a):not(button):not(input):not(select):not(textarea)').forEach(el => {
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
      el.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        el.click();
      });
    });
  }

  function watchCartActions() {
    document.addEventListener('submit', event => {
      const form = event.target;
      if (form && form.matches('form[action*="/cart/add"]')) {
        announce('Adding item to cart.');
      }
    }, true);

    document.addEventListener('click', event => {
      const button = event.target.closest('button[name="add"], button[type="submit"], .product-form__submit');
      if (button && button.closest('form[action*="/cart/add"]')) {
        announce('Adding item to cart.');
      }
    }, true);
  }

  function addFooterStatementLink() {
    const footer = document.querySelector('footer');
    if (!footer || footer.querySelector(`a[href="${STATEMENT_PATH}"]`)) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'tbk-accessibility-footer-link';

    const link = document.createElement('a');
    link.href = STATEMENT_PATH;
    link.textContent = 'Accessibility';
    wrapper.appendChild(link);

    const target = footer.querySelector('.footer__content-bottom, .footer__content-top') || footer;
    target.appendChild(wrapper);
  }

  function run() {
    ensureMainContentTarget();
    labelIconControls();
    normalizeMissingImageAlts();
    labelQuantityInputs();
    ensureAriaReferenceTargets();
    addMissingSubmitButtons();
    applyInlineContrastFixes();
    makeClickableBlocksKeyboardUsable();
    addFooterStatementLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  watchCartActions();
  document.addEventListener('shopify:section:load', run);
})();